import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import CreditReportTableLoader from "./loaders/credit-report-table-loader.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "AdditionalCreditReportTable",
  components: {
    CreditReportTableLoader
  },
  props: {
    creditReports: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const columnsTable = ref(["name", "dateObtained", "status", "type", "id", "actions"]);
    const options = computed(() => ({
      filterable: false,
      sortable: ["name", "dateObtained", "status"],
      sortIcon: {
        base: "fa",
        up: "fa-sort-up",
        down: "fa-sort-down",
        is: "fa-sort"
      },
      showChildRowToggler: false,
      perPage: 999999,
      hiddenColumns: ["id"],
      columnsDisplay: {
        dateObtained: "min_desktop"
      },
      headings: {
        name: t("account.name"),
        dateObtained: t("direct-to-lender.creditBureau.dateObtained"),
        status: t("global.words.requestStatus"),
        type: t("direct-to-lender.creditBureau.type"),
        actions: t("global.words.responseDetails")
      },
      texts: {
        count: ""
      },
      tabbable: false,
      skin: "table table-hover"
    }));
    const {
      creditReports
    } = toRefs(props);
    const loadingPreview = ref([{
      loading: false
    }]);
    watch(creditReports, newVal => {
      loadingPreview.value = [..._mapInstanceProperty(newVal).call(newVal, () => ({
        loading: false
      })), {
        loading: false
      }];
    }, {
      immediate: true
    });
    const stopLoader = index => {
      loadingPreview.value[index].loading = false;
    };
    const handlePreview = ({
      row,
      index
    }) => {
      loadingPreview.value[index].loading = true;
      emit("preview-additional-report", {
        index,
        pdfDocumentId: row.transactionId
      });
    };
    return {
      columnsTable,
      handlePreview,
      stopLoader,
      options,
      loadingPreview
    };
  }
});